import Request from '../modules/request.js'
import Notify from '../modules/notify.js'

const getValue = (arg) => {
  let tag = document.getElementById(arg);
  return tag.value;
}

const emailValid = () => {
  let field = document.getElementById('user_email');
  let user = field.value.substring(0, field.value.indexOf("@"));
  let domain = field.value.substring(field.value.indexOf("@")+ 1, field.value.length);

  if ((user.length >=1) &&
      (domain.length >=3) &&
      (user.search("@")==-1) &&
      (domain.search("@")==-1) &&
      (user.search(" ")==-1) &&
      (domain.search(" ")==-1) &&
      (domain.search(".")!=-1) &&
      (domain.indexOf(".") >=1)&&
      (domain.lastIndexOf(".") < domain.length - 1)) {
    return true;
  }
  else {
    return false;
  }
}

const setContactSubmit = (callback) => {
  let btn = document.querySelector('[contact-submit]');
  if (btn == undefined) {
    return 0;
  }
  btn.onclick = () => {
    callback();
  }
}

class Home {
  constructor() {
    setContactSubmit(this.sendContact)
  }

  sendContact() {
    // pegar valores
    let firstName = getValue('user_first_name');
    let phone = getValue('user_phone');
    let email = getValue('user_email');
    let message= getValue('user_message');
    let auth_token = document.getElementsByName('authenticity_token')[0].value;
    // console.log(emailValid());
    if (emailValid()) {
      const request = new Request();
      let params = `authenticity_token=${auth_token}&user[first_name]=${firstName}&user[phone]=${phone}&user[email]=${email}&user[message]=${message}`;
      request.post('/create-contact', params, (request, response) => {
        new Notify().delivery(response.data);
      });
    }
  }

}

export default Home;
